/**
 * Generates a random integer between min and max (inclusive).
 * If max is not provided, generates a random integer between 0 and min (exclusive).
 * @param {number} min - The minimum value (inclusive) or upper bound if max is not provided
 * @param {number} [max] - The maximum value (inclusive)
 * @returns {number} A random integer
 * @example
 * randomInt(5) // returns a random integer between 0 and 4
 * randomInt(1, 10) // returns a random integer between 1 and 10
 */
export const randomInt = (min: number, max: number): number => {
    return max === undefined
        ? Math.floor(Math.random() * min)
        : min + Math.floor(Math.random() * (max - min + 1));
};
